// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1V9Qd","box":"WorkspacesBox_box__25JSH","node":"WorkspacesBox_node__nL3Cw"};